import { apis } from '@/services/api';
import { Thread, Network } from '@movilizame/networking';
import { Geocoding } from '@/services/geocoding';
import { executeOnceInTime } from '@/services/utility';
import globalStore from '../../index';
import { playSound } from '@/services/Audio';
import dialogs from '@/services/dialogs.js';
// import translate from '@/services/language';
import { LangManager } from '@/services/language';
import { TRIP_STATE } from '../../mutation-types';
import bus from '@/services/bus-event';
import router from '@/router';
import { KeepAwake } from '@capacitor-community/keep-awake';
import { isBlacklistedTokenError } from '@/services/api/authError';
import { reservationAdvanceAllowed, reservationAdvanceErrorMessage } from '@/services/reservation';

let choferesApi = apis.choferesApi;
let checkingStateFlag = false;
let ignoreNextCheckState = false;

function shouldStayOnReservasRoute () {
    const route = router && router.currentRoute;
    const routeName = route && route.name;
    return routeName === 'reservas';
}

function resetState (store) {
    store.commit('RESET_STATES');
}

const byPassError = (err) => {
    if (isBlacklistedTokenError(err)) {
        if (globalStore.getters['auth/checkLogin']) {
            globalStore.dispatch('auth/logout'); // Token inválido/blacklisted -> cerrar sesión.
        }
        return;
    }
    if (err && err.status === 403 && err.data === 'user-inactive') {
        dialogs.message(LangManager.translate('userInactive'), { duration: 10, estado: 'error' });
        globalStore.dispatch('auth/logout'); // Cierro sesión
    } else {
        return Promise.reject(err);
    }
};

function isReservationAdvanceAllowed (trip) {
    return reservationAdvanceAllowed(trip, globalStore.getters['company/config']);
}

function handleState (store, data) {
    // [TODO] Call handle notification
    // [TODO] Call handle messages
    let actualTrip = store.state.actualTrip;
    let trip = data.viaje;

    // Check for QR payment status change (only for electronic payment trips)
    if (trip && actualTrip && trip.id === actualTrip.id && trip.pago_electronico) {
        const previousQrPayment = actualTrip.is_qr_payed;
        const currentQrPayment = trip.is_qr_payed;

        // Check if QR payment changed from falsy to truthy (1)
        if (!previousQrPayment && currentQrPayment === 1 && !store.state.qrPaymentNotified[trip.id]) {
            dialogs.message(LangManager.translate('qrPaymentReceived') || 'Pago QR recibido', {
                duration: 5,
                estado: 'success'
            });
            store.commit('MARK_QR_PAYMENT_NOTIFIED', trip.id);
        }
    }

    store.commit('CHANGE_AVAILABILITY', data.disponible);
    if (!data.disponible) {
        // Intento frenar la ubicacion por las dudas
        globalStore.dispatch('geolocation/stop');
    }
    console.log('handle state driver');
    KeepAwake.isSupported().then((isSupported) => {
        console.log('KeepAwake.isSupported', isSupported);
        if (isSupported) {
            console.log('data.disponible', data);
            if (data.disponible) {
                KeepAwake.keepAwake();
            } else {
                KeepAwake.allowSleep();
            }
        }
    }).catch((ex) => {
        console.log('ex keep awake', ex);
    });

    if (store.state.isAvailable !== data.disponible) {
        // si cambió mi estado de disponibilidad debo handlearlo
        handleAvailabilityStateChange(store, data.disponible);
    }

    let offeredTrips = data.ofrecidos;
    if (trip) { // llego un trip
        if (!actualTrip) { // No hay viaje actual
            let history = store.state.tripsHistory.find(item => item.id === trip.id);
            if (history && (history.frontState === TRIP_STATE.CANCELED_BY_USER || history.frontState === TRIP_STATE.CANCELED_BY_PASSENGER || history.frontState === TRIP_STATE.FINISH)) {
                // Viaje fue cancelado o ya finalizo pero no llego al servidor
                // No hacemos nada, la app sola vuelve al estado anterior si falla el cancel
            } else {
                // Cerramos la app y la volvimos abrir. Por ahora no tenemos en cuenta de persistir algunos datos.
                if (trip.choferAbordo) { // choferAbordo
                    trip.frontState = TRIP_STATE.RIDEUP;
                } else { // no estoy abordo
                    if (!trip.llegando) { // o esta aceptado
                        trip.frontState = TRIP_STATE.ACCEPTED;
                    } else { // o llegando
                        trip.frontState = TRIP_STATE.ARRIVED_TO_ORIGIN;
                    }
                }
                // Reservation deferred-payment: don't enter "advance" steps until due and paid.
                if (!isReservationAdvanceAllowed(trip)) {
                    trip.llegando = false;
                    trip.choferAbordo = false;
                    trip.frontState = TRIP_STATE.ACCEPTED;
                }
                store.commit('SET_ACTUAL_TRIP', trip);
                store.dispatch('messages/getMessages', { chatId: trip.id }, {root: true});
            }
        } else { // Hay viaje actual
            if (trip.id === actualTrip.id) { // Chequeo que el viaje no figure como terminado en la historia
                // El usuario no puede modificar nada en el estado del viaje hacia el chofer, más que cancelarlo, así que no hay mucho más que handlear.
                if (actualTrip.frontState) {
                    trip.frontState = actualTrip.frontState;
                }
                trip.llegando = actualTrip.llegando;
                trip.choferAbordo = actualTrip.choferAbordo;
                if (!isReservationAdvanceAllowed(trip)) {
                    trip.llegando = false;
                    trip.choferAbordo = false;
                    trip.frontState = TRIP_STATE.ACCEPTED;
                }
                store.commit('SET_ACTUAL_TRIP', trip);
                store.commit('messages/SET_CURRENT_CONVERSATION', trip.id, { root: true });
            } else {
                if (trip.id > actualTrip.id) { // Caso extremo, seteamos el nuevo trip, borramos el viejo y llamamos el handle nuevamente
                    store.commit('SET_ACTUAL_TRIP', null);

                    console.error('ERROR: actualTrip no es el trip actual');
                    handleState(store, data);
                    return;
                } // El else de este IF, es el caso de que un estado anterior llego tarde, por lo tanto lo ignoro.
            }
        }
    } else {
        // Hay dos caso: el primero sería que el viaje fue cancelado, eso se handlea luego con viajeCancelado, el segundo
        // caso es que tras apretar aceptar haya un problema con el viaje, o llegue un estado viejo, en ambos casos no hay
        // que hacer nada, ignorar.
    }

    if (offeredTrips && offeredTrips.length) { // [CHECK] [TODO] Peligroso, una notificación puede ser pisada por un state viejo.
        console.log('this play notification', store.state.offeredTrip && store.state.offeredTrip.length);
        if ((store.state.offeredTrip && store.state.offeredTrip.length === 0) || !store.state.offeredTrip) {
            playNotification(store, offeredTrips[0].id, 'driverOfrecido', 'taxi');
        }
        store.commit('SET_OFFERED_TRIPS', offeredTrips);
    } else {
        store.commit('SET_OFFERED_TRIPS', []);
    }

    if (data.viajeCancelado) {
        if (actualTrip) {
            if (actualTrip.id === data.viajeCancelado.id) { // Si el viaje cancelado de backend, es mi viaje actual, lo mando a dormir
                actualTrip.frontState = TRIP_STATE.CANCELED_BY_PASSENGER;
                store.commit('ADD_HISTORY_TRIP', actualTrip);
                store.commit('SET_ACTUAL_TRIP', null);
                store.commit('SET_ACTUAL_TRIP_METADATA', null);
                playNotification(store, actualTrip.id, 'driverCanceled', 'cancel_pacman');
                console.log('SET_CANCELED_TRIP', data.viajeCancelado);
                store.commit('SET_CANCELED_TRIP', data.viajeCancelado);
                if (!shouldStayOnReservasRoute()) {
                    router.push({
                        name: 'home'
                    });
                }
            } else {
                console.error('ERROR CRÍTICO: El ID del viaje cancelado recibido del servidor no coincide con el ID del viaje actual.');
                if (data.viajeCancelado.id > actualTrip.id) { // Si el viajeCancelado tiene un ID mayor a mi viaje actual, desecho mi viaje.
                    actualTrip.frontState = TRIP_STATE.CANCELED_BY_PASSENGER;
                    store.commit('ADD_HISTORY_TRIP', actualTrip);
                    store.commit('SET_ACTUAL_TRIP', null);
                    store.commit('SET_ACTUAL_TRIP_METADATA', null);
                    // playNotification(store, actualTrip.id, 'driverCanceled', 'cancel_pacman');
                }
            }
        } else {
            let history = store.state.tripsHistory.find(item => item.id === data.viajeCancelado.id);
            if (!history) {
                playNotification(store, data.viajeCancelado.id, 'driverCanceled', 'cancel_pacman'); // Este caso se da cuando cerre la app.
                console.log('SET_CANCELED_TRIP', data.viajeCancelado);
                store.commit('SET_CANCELED_TRIP', data.viajeCancelado);
                store.commit('ADD_HISTORY_TRIP', data.viajeCancelado);
            }
        }
        // cancelarVisto();
    }

    if (data.mensajes) {
        globalStore.commit('messages/SET_MESSAGES', data.mensajes); // Cierro sesión
    }

    if (data.viajes_perdidos && data.viajes_perdidos.length) {
        store.commit('SET_MISSED_TRIPS', data.viajes_perdidos);
    } else {
        store.commit('SET_MISSED_TRIPS', []);
    }
}

function markAsAlerted (store, trip) {
    store.commit('MARK_AS_ALERTED_MISSING', trip);
}

function playNotification (store, tripId, action, sound, muted, url) {
    let state = store.state.alreadyPlayedNotifications;
    console.log('alreadyPlayedNotifications', action, tripId, state, sound);
    if (globalStore.getters['cordova/foreground']) {
        if (tripId) {
            if (!state[action][tripId] && !muted) {
                if (sound) {
                    playSound(sound, url);
                }
            }
        } else {
            if (sound) {
                playSound(sound, url);
            }
        }
    }
    store.commit('SET_PLAYED_NOTIFICATONS', action, tripId);
}

function handlerNotification (store, notification) {
    console.log('driver handlerNotification', notification.url, notification);
    let trip;
    console.log('notification handler', notification);
    let notificationTripId = parseInt(notification.viaje_id, 10);
    switch (notification.url) {
        case 'llegando':
        case 'aceptar':
            console.error('Error en backend');
            break;
        case 'cancelar':
            trip = store.state.actualTrip;
            if (notification.trip) {
                trip = notification.trip;
            }
            if (trip && (trip.id === notificationTripId)) {
                trip.frontState = TRIP_STATE.CANCELED_BY_PASSENGER;
                store.commit('ADD_HISTORY_TRIP', trip);
                store.commit('SET_ACTUAL_TRIP', null);
                store.commit('SET_ACTUAL_TRIP_METADATA', null);
                store.commit('SET_OFFERED_TRIPS', []);
                console.log('SET_CANCELED_TRIP', trip);
                store.commit('SET_CANCELED_TRIP', trip);
                console.log('to playNotification driverCanceled');
                const sound = notification.sound || 'cancel_pacman';
                playNotification(store, notificationTripId, 'driverCanceled', sound, true, notification.url);
                if (!shouldStayOnReservasRoute()) {
                    router.push({
                        name: 'home'
                    });
                }
            } else {
                if (store.state.offeredTrips.length) {
                    let offeredTrip = store.state.offeredTrips.find(t => t.id === notificationTripId);
                    if (offeredTrip) {
                        // store.commit('SET_ACTUAL_TRIP', null);
                        store.commit('SET_OFFERED_TRIPS', []);
                    }
                }
            }

            break;
        case 'ofrecidos':
            console.log('to playNotification driverOfrecido', store.state.offeredTrips.length);
            if (store.state.offeredTrips.length === 0) {
                const sound = notification.sound || 'taxi';
                playNotification(store, notificationTripId, 'driverOfrecido', sound, true, notification.url);
            }
            trip = notification.trip;
            if (trip) {
                if (checkingStateFlag) {
                    ignoreNextCheckState = true;
                }
                store.commit('ADD_OFFERED_TRIPS', trip);
            }

            break;
        case 'nuevo-mensaje':
        case 'nuevo-audio':
            if (notification && notification._original && notification._original.additionalData && notification._original.additionalData.chat) {
                let m = notification._original.additionalData.chat;
                globalStore.commit('messages/SET_MESSAGE', m);
                const sound = notification.sound || 'new_message';
                playNotification(store, null, 'newMessage', sound, false, notification.url);
            }
            break;
        case 'reserva-pagada':
            {
                const sound = notification.sound || 'bell';
                playNotification(store, notificationTripId, 'reservationPaid', sound, true, notification.url);
                const msg = notification.content || LangManager.translate('reservaPagadaChofer');
                dialogs.message(msg, { duration: 12, estado: 'success' });
                if (!shouldStayOnReservasRoute()) {
                    router.push({ name: 'reservas' });
                }
            }
            break;
        case 'reserva-proxima':
            {
                const sound = notification.sound || 'taxi';
                playNotification(store, notificationTripId, 'reservationProximity', sound, true, notification.url);
                if (notification.foreground && notification.content) {
                    dialogs.message(notification.content, { duration: 12, estado: 'success' });
                }
            }
            break;
    }
}

function init (store, flag) {
    let threadAction = function ({ next, times, data, register }) {
        let store = data;
        let t = checkState(store).then(() => {
            next();
        }).catch((error) => {
            console.error(error);
            next();
        });
        register(t);
    };

    if (flag) {
        let t = new Thread({ interval: 10000, runImmediately: true });
        t.action(threadAction).tag('check-state').run(store);
    } else {
        Thread.stopThreads('check-state');
    }
}

// Todo make thread que consuma esta acción
function checkState (store) {
    // [TODO] Set timestamps
    checkingStateFlag = true;
    return choferesApi.estado().then(data => {
        console.log('chofer estado', data, ignoreNextCheckState);
        checkingStateFlag = false;
        if (!ignoreNextCheckState) {
            handleState(store, data);
        } else {
            ignoreNextCheckState = false;
        }
    }).catch(err => {
        console.log(err);
        checkingStateFlag = false;
        return byPassError(err);
    });
}

function cancelTrip (store, data) {
    let trip = store.state.actualTrip;
    trip.frontState = TRIP_STATE.CANCELED_BY_USER;
    store.commit('ADD_HISTORY_TRIP', trip);
    store.commit('SET_OFFERED_TRIPS', []);
    store.commit('SET_ACTUAL_TRIP', null);
    store.commit('SET_ACTUAL_TRIP_METADATA', null);
    bus.emit('trip_canceled');

    let action = () => { return choferesApi.cancelTrip(data); };
    Network.doItInBackground(action, { retries: 10, interval: 5000 }).then((data) => {
        // Cancel succes
        return true;
    }).catch((error) => {
        if (error.status === 422 && error.data === 'El viaje fue cancelado por la pasajera.') {
            dialogs.message(LangManager.translate('viajeCaneladoPreviamentePorPasajero'), { duration: 10, estado: 'error' });
            playNotification(store, trip.id, 'driverCanceled', 'cancel_pacman');
            return true; // [ToDo] HANDLE -> el pasajero cancelo antes
        } else {
            /**
             * No se pudo realizar la conexion despues de tantos intentos
             * Alertar al usuario y volver al estado atrás.
             */
            console.error(error);
            trip.frontState = TRIP_STATE.ACCEPTED;
            store.commit('SET_ACTUAL_TRIP', trip);
            store.commit('REMOVE_HISTORY_TRIP', trip);
        }
        return byPassError(error);
    });
}

function arrivingToTrip (store, data) {
    let trip = Object.assign({}, store.state.actualTrip);
    if (!isReservationAdvanceAllowed(trip)) {
        dialogs.message(reservationAdvanceErrorMessage(trip), { duration: 10, estado: 'error' });
        return;
    }
    trip.frontState = TRIP_STATE.ARRIVED_TO_ORIGIN;
    trip.llegando = true;
    store.commit('SET_ACTUAL_TRIP', trip);

    let action = () => { return choferesApi.llegandoTrip(data); };

    Network.doItInBackground(action, { retries: 10, interval: 5000 }).then((data) => {
        // Cancel succes
        return true;
    }).catch((error) => {
        if (error.status === 422 && error.data === 'El viaje fue cancelado por el usuario.') {
            store.commit('ADD_HISTORY_TRIP', trip);
            store.commit('SET_OFFERED_TRIPS', []);
            store.commit('SET_ACTUAL_TRIP', null);
            store.commit('SET_ACTUAL_TRIP_METADATA', null);
            dialogs.message(LangManager.translate('viajeCaneladoPreviamentePorPasajero'), { duration: 10, estado: 'error' });
            playNotification(store, trip.id, 'driverCanceled', 'cancel_pacman');
        } else {
            /**
             * No se pudo realizar la conexion despues de tantos intentos
             * Alertar al usuario y volver al estado atrás.
             */
            console.error(error);
            trip.frontState = TRIP_STATE.ACCEPTED;
            trip.llegando = false;
            store.commit('SET_ACTUAL_TRIP', trip);
        }
        return byPassError(error);
    });
}
function startTrip (store, data) {
    let trip = store.state.actualTrip;
    if (!isReservationAdvanceAllowed(trip)) {
        dialogs.message(reservationAdvanceErrorMessage(trip), { duration: 10, estado: 'error' });
        return;
    }
    trip.frontState = TRIP_STATE.RIDEUP;
    trip.choferAbordo = true;
    store.commit('SET_ACTUAL_TRIP', trip);

    let action = () => { return choferesApi.takeTrip(data); };

    Network.doItInBackground(action, { retries: 10, interval: 5000 }).then((data) => {
        if (data && typeof data === 'object' && data.precio !== undefined && data.precio !== null) {
            trip.precio = data.precio;
            store.commit('SET_ACTUAL_TRIP', trip);
        }
        return true;
    }).catch((error) => {
        if (error.status === 422 && error.data === 'El viaje fue cancelado por el usuario.') {
            store.commit('ADD_HISTORY_TRIP', trip);
            store.commit('SET_OFFERED_TRIPS', []);
            store.commit('SET_ACTUAL_TRIP', null);
            store.commit('SET_ACTUAL_TRIP_METADATA', null);
            dialogs.message(LangManager.translate('viajeCaneladoPreviamentePorPasajero'), { duration: 10, estado: 'error' });
            playNotification(store, trip.id, 'driverCanceled', 'cancel_pacman');
        } else {
            /**
             * No se pudo realizar la conexion despues de tantos intentos
             * Alertar al usuario y volver al estado atrás.
             */
            trip.frontState = TRIP_STATE.ARRIVED_TO_ORIGIN;
            trip.choferAbordo = false;
            store.commit('SET_ACTUAL_TRIP', trip);
        }
        return byPassError(error);
    });
}
function arrivedToDestination (store, data) {
    console.log('arrivedToDestination');
    let trip = store.state.actualTrip;
    if (!isReservationAdvanceAllowed(trip)) {
        dialogs.message(reservationAdvanceErrorMessage(trip), { duration: 10, estado: 'error' });
        return;
    }
    trip.frontState = TRIP_STATE.ARRIVED_TO_DESTINATION;
    store.commit('SET_ACTUAL_TRIP', trip);
    calculateTripStatics(store, trip);
    console.log('arrivedToDestination', trip);
    return choferesApi.arriboDestino().then(data => {
        console.log('chofer arriboDestino', data);
        return data;
    }).catch(err => {
        console.log('arrivedToDestination err', err);
        return byPassError(err);
    });
}

function calculateTripStatics (store, trip) {
    // [TODO] Set timestamps
    let origin = { lat: trip.lat, lng: trip.lng };
    let destination;
    if (globalStore.getters['company/config'].modulo_destino_viaje) {
        destination = { lat: trip.dest_lat, lng: trip.dest_lng };
    } else {
        destination = globalStore.getters['geolocation/actual'];
    }
    debounceDirectionsService(store, origin, destination);
}

const debounceDirectionsService = executeOnceInTime((store, origin, destination) => {
    // Get geocoding runtime from settings, default to 'google'
    let settings = globalStore.getters['company/config'];
    let runtime = (settings && settings.modulo_geocoding) || 'google';
    let geocoding = new Geocoding(runtime);
    return geocoding.calculateRoute(origin, destination).then(data => {
        let actualTrip = store.state.actualTrip;
        if (actualTrip) {
            store.commit('SET_ACTUAL_TRIP_METADATA', data);
        }
    }).catch(err => {
        console.error(err);
        return byPassError(err);
    });
}, 60000);

function recordTrip (store, data) {
    let trip = store.state.actualTrip;
    if (!isReservationAdvanceAllowed(trip)) {
        dialogs.message(reservationAdvanceErrorMessage(trip), { duration: 10, estado: 'error' });
        return;
    }
    trip.frontState = TRIP_STATE.FINISH;
    store.commit('ADD_HISTORY_TRIP', trip);
    store.commit('SET_OFFERED_TRIPS', []);
    store.commit('SET_ACTUAL_TRIP', null);
    store.commit('SET_ACTUAL_TRIP_METADATA', null);
    globalStore.dispatch('geolocation/adquireNewPosition');
    globalStore.dispatch('messages/endChat');

    let action = () => { return choferesApi.endTrip(data); };

    Network.doItInBackground(action, { retries: 10, interval: 5000 }).then((data) => {
        // Cancel succes
        return true;
    }).catch((err) => {
        /**
         * No se pudo realizar la conexion despues de tantos intentos
         * Alertar al usuario y volver al estado atrás.
         */
        console.error(err);
        trip.frontState = TRIP_STATE.ARRIVED_TO_DESTINATION;
        store.commit('SET_ACTUAL_TRIP', trip);
        store.commit('REMOVE_HISTORY_TRIP', trip);
        calculateTripStatics(store, trip);
        return byPassError(err);
    });
}
function updatePosition (store, data) {
    return choferesApi.location(data);
}
function acceptTrip (store, data) {
    let trip = null;
    if (data.trip) {
        store.commit('ADD_OFFERED_TRIPS', data.trip);
    }
    console.log('viajes ofrecidos', store.state.offeredTrips);
    if (store.state.offeredTrips && store.state.offeredTrips.length) {
        trip = store.state.offeredTrips.find(trip => trip.id === data.viaje_id);
        if (trip) {
            let action = () => { return choferesApi.acceptTrip(data); };

            return Network.doItInBackground(action, 10).then((data) => {
                trip.frontState = TRIP_STATE.ACCEPTED;
                trip.llegando = false;

                const remainingTrips = (store.state.offeredTrips || []).filter(item => item.id !== trip.id);
                store.commit('SET_OFFERED_TRIPS', remainingTrips);
                store.commit('SET_VIEWED_OFFERED_TRIP', trip.id);

                if (trip.es_con_reserva) {
                    // Reservation acceptance should not lock driver UI in an active-trip card.
                    store.commit('SET_ACTUAL_TRIP', null);
                    store.commit('SET_ACTUAL_TRIP_METADATA', null);
                    dialogs.message('Reserva aceptada correctamente. Revisa su estado en Reservas.', { duration: 6, estado: 'success' });
                    router.push({ name: 'reservas' });
                } else {
                    store.commit('SET_ACTUAL_TRIP', trip);
                    store.commit('SET_ACTUAL_TRIP_METADATA', null);
                }
                return true;
            }).catch((error) => {
                console.log('error aceptar');
                if (error.status === 422 && error.data === 'La solicitud de viaje fue cancelada por la pasajera.') {
                    dialogs.message(LangManager.translate('viajeOfrecidoCancelado'), { duration: 10, estado: 'error' });
                } else if (error.status === 422 && error.data === 'El viaje fue tomado por otra taxista.') {
                    dialogs.message(LangManager.translate('viajeOfrecidoTomadoPorOtroChofer'), { duration: 10, estado: 'error' });
                } else {
                    console.error(error);
                }
                let actualTrip = store.state.actualTrip;
                if (actualTrip) {
                    playNotification(store, actualTrip.id, 'driverCanceled', 'cancel_pacman');
                    actualTrip.frontState = TRIP_STATE.ACCEPTED_REFUSED;
                    store.commit('ADD_HISTORY_TRIP', actualTrip);
                }
                store.commit('SET_ACTUAL_TRIP_METADATA', null);
                store.commit('SET_ACTUAL_TRIP', null);
                store.commit('SET_OFFERED_TRIPS', []);
                return byPassError(error);
            });
        };
    }
    store.commit('SET_ACTUAL_TRIP', null);
    return Promise.resolve();
}

function ignoreTripLocally (store) {
    if (store.state.offeredTrips && store.state.offeredTrips.length) {
        store.commit('SET_VIEWED_OFFERED_TRIP', store.state.offeredTrips[0].id);
        store.commit('POP_OFFERED_TRIPS');
    }
}

function ignoreTrip (store, data) {
    if (data.trip) {
        store.commit('ADD_OFFERED_TRIPS', data.trip);
    }
    ignoreTripLocally(store);

    let action = () => { return choferesApi.ignoreTrip(data); };

    Network.doItInBackground(action, 10).then((data) => {
        // Cancel succes
        return true;
    }).catch((error) => {
        console.error(error);
        return byPassError(error);
    });
}

function ignoreTripPostAppearence (store, data) {
    store.commit('REMOVE_MISSED_TRIPS', {
        id: data.viaje_id
    });

    let action = () => { return choferesApi.ignoreTrip(data); };

    try {
        let json = window.localStorage.getItem('missed_trip');
        if (!json) {
            json = '[]';
        }
        let missedTrip = JSON.parse(json);
        missedTrip.push(data);
        window.localStorage.setItem('missed_trip', JSON.stringify(missedTrip));
    } catch (ex) {
        console.log('storage missed trip', ex);
    }

    Network.doItInBackground(action, 10).then((data) => {
        // Cancel succes
        return true;
    }).catch((error) => {
        console.error(error);
        return byPassError(error);
    });
}

function updateTripPrice (store, data) {
    let action = () => { return choferesApi.updateTripPrice(data); };

    Network.doItInBackground(action, 10).then((data) => {
        // Cancel succes
        return true;
    }).catch((error) => {
        console.error(error);
        return byPassError(error);
    });
}

function handleAvailabilityStateChange (store, newState) {
    if (newState) {
        globalStore.dispatch('geolocation/start', 'background');
        // globalStore.commit('geolocation/LOCATION_ENABLED_SET', true);
    } else {
        globalStore.dispatch('geolocation/stop');
        // globalStore.commit('geolocation/LOCATION_ENABLED_SET', false);
    }
    store.commit('CHANGE_AVAILABILITY', newState);
}

function changeAvailability (store, data) {
    console.log('changeAvailability', data);
    let post = {
        estado: data
    };
    Object.assign(post, store.rootGetters['cordova/deviceData']);
    handleAvailabilityStateChange(store, data);

    let action = () => { return choferesApi.changeState(post); };

    Network.doItInBackground(action, 10).then((data) => {
        // Cancel succes
        return true;
    }).catch((err) => {
        console.error(err);
        handleAvailabilityStateChange(store, !data);
    });
}

function cancelarVisto (store, id) {
    console.log('SET_CANCELED_TRIP', null);
    store.commit('SET_CANCELED_TRIP', null);
    let action = () => { return choferesApi.markCancelTrip(id); };
    Network.doItInBackground(action, { retries: 10, interval: 5000 }).then((data) => {
        return true;
    }).catch((err) => {
        /**
         * No se pudo realizar la conexion despues de tantos intentos
         * Alertar al usuario y volver al estado atrás.
         */
        console.error(err);
        return byPassError(err);
    });
}

export default {
    resetState,
    init,
    checkState,
    arrivingToTrip,
    cancelTrip,
    startTrip,
    arrivedToDestination,
    recordTrip,
    updatePosition,
    acceptTrip,
    ignoreTrip,
    ignoreTripLocally,
    changeAvailability,
    handlerNotification,
    updateTripPrice,
    ignoreTripPostAppearence,
    markAsAlerted,
    cancelarVisto
};



// WEBPACK FOOTER //
// ./src/store/modules/driver/actions.js